<div class="service-el-container" [style]="getBackground()">
  <div class="service-el-title">
    <app-texts
      [texts]="service.title"
    />
  </div>
  <div *ngIf="service.subtitle && service.subtitle[0] && service.subtitle[1]" class="service-el-subtitle">
    <app-texts
      [texts]="[
      {text: [service.subtitle[0], service.subtitle[1]]}
    ]"
    />
  </div>
  <div class="service-el-container-vail" [style]="getVail()"></div>
</div>
